<template>
    <heading>{{ $t("Vote server") }}</heading>

    <div class="overflow-auto">
        <table v-if="!state.successRedeem && canRedeem && doubleVoteCheckPassed" class="user-actions-table">
            <tbody>
            <tr>
                <td>
                    <img src="https://metin2pserver.net/assets/img/metin2-pserver-toplist-logo.png"
                         alt="metin2pserver.net">
                </td>
                <td>
                <span v-if="state.m2pnet">
                    <i class="fa-solid fa-circle-check"></i>
                </span>
                    <span v-else>
                    <a :href="route('user.vote4coins.vote', {providerId: 0})"
                       target="_blank"
                       class="btn">{{ $t("Vote") }}
                </a>
                </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-5" v-if="doubleVoteCheckPassed">
        <div v-if="canRedeem">
            <div v-if="hasValidVotes">
                <Button size="big" @click="claimPrize">
                    {{ $t("Claim prize") }}
                </Button>
            </div>
            <div v-else>
                <Button size="big" @click="checkVotes" ref="checkVotesButton">
                    {{ $t("Check votes") }}
                </Button>
            </div>
        </div>
        <div v-else>
            {{ $t("You will be able to vote again :time", {time: props.nextRedeem}) }}
        </div>
    </div>

    <Alert v-if="!doubleVoteCheckPassed" type="error">
        <template #title>
            {{ $t("Error") }}
        </template>
        {{ $t("You can vote each 24 hours. Multiple accounts are not allowed.") }}
    </Alert>
</template>

<script setup>
import {usePage} from "@inertiajs/inertia-vue3";
import {computed, reactive, ref} from "vue";
import Button from "@/Shared/Button";
import Heading from "@/Shared/Heading";
import axios from "axios";
import {Inertia} from "@inertiajs/inertia";
import Alert from "@/Shared/Alert";

const user = computed(() => usePage().props.value.user)

const props = defineProps({
    canRedeem: Boolean,
    validVotes: Boolean,
    nextRedeem: String,
    doubleVoteCheckPassed: Boolean
})

const state = reactive({
    validVotes: props.validVotes,
    successRedeem: false,
    m2pnet: usePage().props.value.user.v4c_mp2s_net,
})

const checkVotesButton = ref(null)

function checkVotes() {
    checkVotesButton.value.toggleLoading();
    axios.get(route("user.vote4coins.check_vote"))
        .then((response) => {
            state.m2pnet = response.data.m2pnet
        });
    checkVotesButton.value.toggleLoading();
}

const hasValidVotes = computed(() => state.m2pnet)
const config = computed(() => usePage().props.value.config)

function claimPrize() {
    Inertia.post(route('user.vote4coins.claim_prize'), {}, {
        preserveScroll: true
    });
}

</script>
